"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOptionLabelSingleLine = exports.getOptionLabelSearched = exports.defaultAddressFormat = void 0;
const getOptionLabelSingleLine = (lineNumber, item, addressFormat) => {
  if (addressFormat.lines[lineNumber]) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion -- TODO: update this
    const {
      fields,
      separators
    } = addressFormat.lines[lineNumber];
    let result = '';
    fields.forEach((field, idx) => {
      const correctField = field.charAt(0).toLowerCase() + field.slice(1);
      if (correctField === 'zipCode') {
        result += `${item.zipcode}${separators[idx + 1]}`;
      } else {
        const newField = item[correctField];
        if (newField && newField !== '') {
          result += `${newField}${separators[idx + 1]}`;
        }
      }
    });
    return `${separators[0]}${result}${separators.at(-1)}`;
  }
  return item.streetAddress ?? '';
};
exports.getOptionLabelSingleLine = getOptionLabelSingleLine;
const defaultAddressFormat = exports.defaultAddressFormat = {
  type: 'SingleLine',
  lines: [{
    fields: ['streetAddress'],
    separators: ['', '']
  }]
};
const getOptionLabelSearched = (lineNumber, item, formatAddress) => {
  if (formatAddress?.lines[lineNumber]) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion -- TODO: update this
    const {
      fields,
      separators
    } = formatAddress.lines[lineNumber];
    let result = '';
    fields.forEach((field, idx) => {
      const correctField = field.charAt(0).toLowerCase() + field.slice(1);
      if (correctField === 'zipCode' && item.zipcode !== '') {
        result += `${item.zipcode}${separators[idx + 1]}`;
      } else {
        const newField = item[correctField];
        if (newField && newField !== '') {
          result += `${newField}${separators[idx + 1]}`;
        }
      }
    });
    return `${separators[0]}${result}${separators.at(-1)}`;
  }
  return '';
};
exports.getOptionLabelSearched = getOptionLabelSearched;
//# sourceMappingURL=addressFormatHelper.js.map